@if (waiting()) {
  <div class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Loading COIs...</p>
  </div>
} @else {
  @if (coiObjectArray().length > 0) {
    <div class="connections-list">
      @for (coi of coiObjectArray(); track coi.coiNum) {
        <mat-card class="connection-card" (click)="navigateToCoi(coi)">
          <mat-card-content class="card-content">
            <div class="card-icon">
              <mat-icon>verified_user</mat-icon>
            </div>
            <div class="card-details">
              <div class="card-title">{{ coi.coiId || 'Unnamed COI' }}</div>
              <div class="card-chips">
                @if (coi.status) {
                  <mat-chip-set>
                    <mat-chip>{{ coi.status }}</mat-chip>
                  </mat-chip-set>
                }
              </div>
              <div class="card-meta">
                @if (extractPartyName(coi.partyProvidingCoi) || coi.partyProvidingCoiFriendlyName) {
                  <span class="meta-item">
                    <mat-icon class="meta-icon">business</mat-icon>
                    Provider: {{ coi.partyProvidingCoiFriendlyName || extractPartyName(coi.partyProvidingCoi) }}
                  </span>
                }
                @if (extractPartyName(coi.insuredParty) || coi.insuredPartyFriendlyName) {
                  <span class="meta-item">
                    <mat-icon class="meta-icon">shield</mat-icon>
                    Insured: {{ coi.insuredPartyFriendlyName || extractPartyName(coi.insuredParty) }}
                  </span>
                }
                @if (coi.effectiveDate) {
                  <span class="meta-item">
                    <mat-icon class="meta-icon">event</mat-icon>
                    {{ formatDate(coi.effectiveDate) }} - {{ formatDate(coi.expirationDate) }}
                  </span>
                }
              </div>
            </div>
            <mat-icon class="nav-arrow">chevron_right</mat-icon>
          </mat-card-content>
        </mat-card>
      }
    </div>
  } @else {
    <mat-card class="empty-state">
      <mat-card-content>
        <mat-icon>verified_user</mat-icon>
        <p>No COIs associated</p>
      </mat-card-content>
    </mat-card>
  }
}
